import type { VariantProps } from 'class-variance-authority';

import { cva } from 'class-variance-authority';

export const tagVariants = cva(
	'flex items-center justify-center gap-2 rounded-[2px] px-2 py-0.5 xl:py-1',
	{
		variants: {
			variant: {
				primary: 'bg-primary-light-4',
				beige: 'bg-beige'
			}
		},
		defaultVariants: {
			variant: 'beige'
		}
	}
);

export type TagVariants = VariantProps<typeof tagVariants>;
